/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref } from "vue";
import { type AnyZodObject, type SafeParseReturnType } from "zod";

export function useControlValidation(getRules: () => AnyZodObject) {
  const rules = ref(getRules());
  const result = ref<
    undefined | SafeParseReturnType<Record<string, any>, Record<string, any>>
  >();

  const validate = (formData: any): boolean => {
    result.value = rules.value.safeParse(formData);

    return <boolean>result.value?.success;
  };

  return {
    rules,
    result,
    validate,
  };
}
